module.exports = `${require.publicPath}robot-sample.31a7c734.png`;